// extracted by css-extract-rspack-plugin
export default {"popupContentContainer":"PromotionalPopup_popupContentContainer__rcE-A","closeButtonContainer":"PromotionalPopup_closeButtonContainer__CgQBE"};